import React, { useState, useEffect } from 'react'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import MuiPhoneNumber from 'material-ui-phone-number'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Alert from '@mui/material/Alert'
import { ToastContainer, toast } from 'react-toastify'
import { Apis } from 'app/Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import validator from 'validator'
import { useNavigate } from 'react-router-dom'
import { StaticData } from 'app/utils/constant'
const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const AddUser = () => {
    const [imgdata, setImgdata] = useState()
    const [phoneNum, setPhoneNum] = useState()
    const [emailErr, setEmailErr] = useState()
    const [alldata, setAllData] = useState({
        name: '',
        username: '',
        email: '',
        role: '',
        address: '',
    })
    const [message, setMessage] = useState()
    const navigate = useNavigate()
    const imageUrl = imgdata?.name
        ? URL.createObjectURL(imgdata)
        : StaticData.profileImage
    const imgHandleChange = (e) => {
        setImgdata(e.target.files[0])
    }

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    const validateEmail = (value) => {
        if (validator.isEmail(value)) {
            setEmailErr(true)
        } else {
            setEmailErr('Contains invalid characters!')
        }
    }

    useEffect(() => {
        validateEmail(alldata.email || '')
    })

    const handleSubmit = () => {
        var formdata = new FormData()
        formdata.append('name', alldata.name)
        formdata.append('username', alldata.username)
        formdata.append('role', alldata.role)
        formdata.append('email', alldata.email)
        formdata.append('address', alldata.email)
        formdata.append('mobilenumber', phoneNum)

        formdata.append('image', imgdata === undefined ? 'undefined' : imgdata)
        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                // Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0MmViNjA2OWI5Zjk2NWZkNDQwNjM2YyIsImVtYWlsIjoidGVzdDEwMDEuZGRzQGdtYWlsLmNvbSIsImlhdCI6MTY4NDk5NTEyNywiZXhwIjozMzc1MTc0MjU0fQ.CiZejjs3hnSnXV7RPTsk3XKHbY8SLaafSFJFNNQtheQ`,
            },
        }

        if (
            !alldata.name ||
            !alldata.username ||
            !alldata.role ||
            !alldata.email ||
            !alldata.address ||
            !phoneNum
        ) {
            if (!alldata.name) {
                setMessage('Name is required !')
            } else {
                if (!alldata.username) {
                    setMessage('Username is required !')
                } else {
                    if (!alldata.email || emailErr != true) {
                        !alldata.email
                            ? setMessage('Email is required !')
                            : setMessage('Add valid email!')
                    } else {
                        if (!phoneNum) {
                            setMessage('Phone number is required !')
                        } else {
                            if (!alldata.role) {
                                setMessage('Role is required !')
                            } else {
                                if (!alldata.address) {
                                    setMessage('Address is required !')
                                }
                            }
                        }
                    }
                }
            }
        } else {
            axios
                .post(`${Apis.addRole}`, formdata, config)
                .then((res) => {
                    setMessage([
                        res?.data?.message || 'Role added successfully',
                        res?.data?.code,
                    ])
                    setTimeout(() => {
                        navigate('/dashboard/rolemanagement')
                    }, 2000)
                })
                .catch((err) => {
                    console.log('Error in Add user', err?.response?.data)
                    setMessage(err?.response?.data?.message)
                })
        }

        setTimeout(() => {}, 2000)
    }

    return (
        <Container>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <Link to={'/dashboard/rolemanagement'}>
                <Box sx={{ padding: '15px 0px' }}>
                    <ArrowBackIcon />
                </Box>
            </Link>

            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    marginBottom: 5,
                    fontWeight: 500,
                    fontSize: 20,
                }}
            >
                Add a new user
            </Box>
            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    width: '110%',
                }}
            >
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Name</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Name"
                            type="text"
                            name="name"
                            onChange={handleChange}
                            autoComplete="current-password"
                            sx={{ padding: 0, width: '30vh' }}
                        />{' '}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Username</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',

                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Username"
                            type="text"
                            name="username"
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Email</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Email"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="email"
                            name="email"
                            onChange={handleChange}
                            // sx={{ paddingBottom: 1 }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Phone number</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <MuiPhoneNumber
                            label="Phone Number"
                            defaultCountry={'us'}
                            variant="outlined"
                            name="phone"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            onChange={(e) => {
                                setPhoneNum(e)
                            }}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Role</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Role"
                            type="text"
                            name="role"
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                        >
                            <MenuItem value="Super Admin">Super Admin</MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                            <MenuItem value="doctor">Doctor</MenuItem>
                        </Select>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Address</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Address"
                            multiline
                            name="address"
                            onChange={handleChange}
                            type="text"
                            sx={{ paddingBottom: 1, width: '50vw' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Profile image</Box>{' '}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            width: '50%',
                        }}
                    >
                        <img
                            src={imageUrl || imgdata}
                            alt=""
                            style={{
                                width: '75px',
                                height: '75px',
                                position: 'relative',
                                borderRadius: '50px',
                                left: '2%',
                            }}
                        />
                        <input
                            type="file"
                            id="avatarUpload"
                            style={{ display: 'none' }}
                            onChange={imgHandleChange}
                        />

                        <Box sx={{ marginLeft: 5 }}>
                            <Button variant="contained">
                                <label htmlFor="avatarUpload">
                                    Upload photo
                                </label>
                            </Button>{' '}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Button
                variant="contained"
                sx={{ marginTop: 3 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>

            <ToastContainer />
        </Container>
    )
}

export default AddUser
